<main class="container">
  <section>
    <h2 i18n>Impressum</h2>
    <div class="card">
      <p><strong>EM Zoll Logistik GmbH</strong></p>
      <p>Hartham 1<br/>94152 Neuhaus am Inn</p>
      <p i18n>Telefon: <a href="tel:+491601254970">+49 160 1254970</a></p>
      <p i18n>E-Mail: info@emzoll.de</p>
      <p i18n>Geschäftsführer: Mustafa Göcmen, Esat Yilmaz</p>
      <p i18n>USt-IdNr.: DE455978869</p>
    </div>
  </section>
</main>